import React from 'react';
import GoogleDriveVideo from './GoogleDriveVideo';

/**
 * TeamHeader Component
 * Displays team information with background, logo, name, school, and video
 * Includes responsive layout for mobile and desktop
 * Extracted from Order.js for better maintainability and reusability
 */
const TeamHeader = ({ 
    teamName,
    schoolName,
    teamPhotoUrl,
    teamBackgroundPhotoUrl,
    useTeamBackgroundPhoto,
    teamPrimaryColorHex,
    videoUrl
}) => {
    return (
        <>
            {/* Full Width Team Background Container */}
            <div style={{
                backgroundImage: useTeamBackgroundPhoto && teamBackgroundPhotoUrl ? `url(${teamBackgroundPhotoUrl})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundColor: teamPrimaryColorHex || '#0e456c',
                color: '#fff',
                padding: '3rem 0',
                marginBottom: '2rem',
                position: 'relative',
                overflow: 'hidden',
                width: '100vw',
                marginLeft: 'calc(-50vw + 50%)'
            }}>
                {/* Overlay for better text readability */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 1
                }}></div>
                
                <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="row g-3 align-items-center">
                        {/* Team Header Content */}
                        <div className="col-lg-6">
                            {/* Mobile Layout - Logo left, text right */}
                            <div className="d-lg-none">
                                <div className="row align-items-center" style={{ padding: '1.5rem 1rem' }}>
                                    {teamPhotoUrl && (
                                        <div className="col-4 col-sm-3 text-center">
                                            <img 
                                                src={`https://fundraising-u-production.s3.amazonaws.com/${teamPhotoUrl}`}
                                                alt={`${teamName} logo`}
                                                style={{
                                                    maxHeight: '80px',
                                                    maxWidth: '100%',
                                                    filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.3))',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className={teamPhotoUrl ? "col-8 col-sm-9" : "col-12"}>
                                        <h1 style={{ 
                                            textShadow: '2px 2px 4px rgba(0,0,0,0.5)', 
                                            color: 'white',
                                            fontSize: '1.5rem',
                                            lineHeight: '1.2',
                                            marginBottom: '0.5rem',
                                            wordBreak: 'break-word'
                                        }}>
                                            {teamName}
                                        </h1>
                                        {schoolName && (
                                            <h3 style={{ 
                                                textShadow: '2px 2px 4px rgba(0,0,0,0.5)', 
                                                color: 'white',
                                                fontSize: '1.1rem',
                                                lineHeight: '1.2',
                                                margin: 0,
                                                wordBreak: 'break-word'
                                            }}>
                                                {schoolName}
                                            </h3>
                                        )}
                                    </div>
                                </div>
                            </div>
                            
                            {/* Desktop Layout - Centered */}
                            <div className="d-none d-lg-block" style={{ textAlign: 'center', padding: '2rem' }}>
                                {teamPhotoUrl && (
                                    <img 
                                        src={`https://fundraising-u-production.s3.amazonaws.com/${teamPhotoUrl}`}
                                        alt={`${teamName} logo`}
                                        style={{
                                            maxHeight: '120px',
                                            marginBottom: '1rem',
                                            filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.3))',
                                            objectFit: 'contain'
                                        }}
                                    />
                                )}
                                <h1 style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)', color: 'white' }}>{teamName}</h1>
                                {schoolName && (
                                    <h3 style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)', color: 'white' }}>{schoolName}</h3>
                                )}
                            </div>
                        </div>

                        {/* Team Video Section - Only visible on large screens within background */}
                        {videoUrl && (
                            <div className="col-lg-6 d-none d-lg-block">
                                <div style={{ margin: '2rem' }}>
                                    <GoogleDriveVideo 
                                        videoUrl={videoUrl} 
                                        teamName={teamName}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Team Video Section - Only visible on small/medium screens outside background */}
            {videoUrl && (
                <div className="d-lg-none mb-4">
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '2rem',
                        borderRadius: '10px',
                        border: '1px solid #dee2e6'
                    }}>
                        <h3 style={{ 
                            color: teamPrimaryColorHex || '#0e456c', 
                            marginBottom: '1.5rem',
                            textAlign: 'center' 
                        }}>
                            Watch Our Team's Message
                        </h3>
                        <GoogleDriveVideo 
                            videoUrl={videoUrl} 
                            teamName={teamName}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default TeamHeader;
